import React from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';

const MessageWrapper = styled.div`
  display: flex;
  justify-content: ${props => props.$isUser ? 'flex-end' : 'flex-start'};
  align-items: flex-start;
  gap: 12px;
  margin: 0;
  
  /* 移動端優化 */
  @media (max-width: 768px) {
    gap: 8px;
    margin: 0 0 12px 0;
  }
`;

const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${props => props.$isUser 
    ? '#E2E8F0' 
    : '#F1F5F9'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
  order: ${props => props.$isUser ? 1 : 0};
  
  /* 移動端優化 */
  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }
  
  @media (max-width: 480px) {
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
`;

const Bubble = styled.div`
  max-width: 70%;
  padding: 16px;
  background: ${props => props.$isUser 
    ? '#E9EFF7' 
    : '#FFFFFF'};
  color: ${props => props.$isUser 
    ? '#1E293B' 
    : '#334155'};
  border-radius: ${props => props.$isUser 
    ? '12px' 
    : '16px'};
  border: ${props => props.$isUser ? 'none' : '1px solid #D8DFE8'};
  box-shadow: none;
  position: relative;
  order: ${props => props.$isUser ? 0 : 1};
  word-wrap: break-word;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.4;
  
  /* 移動端優化 */
  @media (max-width: 768px) {
    max-width: 85%;
    padding: 12px 14px;
    font-size: 14px;
    line-height: 1.5;
    border-radius: ${props => props.$isUser 
      ? '12px 12px 4px 12px' 
      : '12px 12px 12px 4px'};
  }
  
  @media (max-width: 480px) {
    max-width: 90%;
    padding: 10px 12px;
    font-size: 13px;
    border-radius: ${props => props.$isUser 
      ? '10px 10px 2px 10px' 
      : '10px 10px 10px 2px'};
  }

  /* Markdown 樣式 */
  p {
    margin: 0 0 16px 0;
    &:last-child {
      margin-bottom: 0;
    }
  }

  ul, ol {
    margin: 16px 0;
    padding-left: 1.5em;
  }

  li {
    margin: 8px 0;
  }

  strong {
    font-weight: 600;
    color: #333333;
  }

  code {
    background: #F1F5F9;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    font-family: monospace;
  }

  pre {
    background: #F1F5F9;
    padding: 12px;
    border-radius: 8px;
    overflow-x: auto;
    margin: 16px 0;
    border: 1px solid #e5e7eb;
    font-size: 14px;
    line-height: 1.4;
  }

  a {
    color: #10a37f;
    text-decoration: none;
    font-size: 10px;
    
    &:hover {
    text-decoration: underline;
    }
  }

  h1, h2, h3 {
    color: #333333;
    margin: 20px 0 17px 0;
    font-weight: 600;
  }

  h1 {
    font-size: 20px;
  }

  h2 {
    font-size: 17px;
  }

  h3 {
    font-size: 16px;
  }

  /* 產品推薦格式化 */
  .product-recommendation {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 12px;
    margin: 8px 0;
  }

  .product-name {
    font-weight: 600;
    font-size: 16px;
    color: #1e293b;
    margin-bottom: 8px;
  }

  .product-company {
    color: #64748b;
    font-size: 14px;
    margin-bottom: 6px;
  }

  .product-function {
    color: #475569;
    font-size: 14px;
    margin-bottom: 6px;
  }

  .product-features {
    color: #475569;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .product-contact {
    font-size: 13px;
    color: #64748b;
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e2e8f0;
  }

  /* 改善標題樣式 */
  h1, h2, h3 {
    color: #1e293b;
    margin: 20px 0 12px 0;
    font-weight: 600;
    border-bottom: 2px solid #e2e8f0;
    padding-bottom: 6px;
  }

  /* 改善段落間距 */
  p {
    margin: 0 0 12px 0;
    line-height: 1.5;
    &:last-child {
      margin-bottom: 0;
    }
  }

  /* 改善列表樣式 */
  ul, ol {
    margin: 12px 0;
    padding-left: 1.5em;
  }

  li {
    margin: 6px 0;
    line-height: 1.4;
  }

  /* 改善強調文字 */
  strong {
    font-weight: 600;
    color: #1e293b;
  }

  /* 改善連結樣式 */
  a {
    color: #3b82f6;
    text-decoration: none;
    font-size: 14px; /* 🔥 增大字體 */
    font-weight: 500;
    padding: 2px 4px; /* 🔥 增加點擊區域 */
    border-radius: 4px; /* 🔥 增加圓角 */
    transition: all 0.2s ease; /* 🔥 增加過渡效果 */
    display: inline-block; /* 🔥 讓padding生效 */
    
    &:hover {
      text-decoration: underline;
      color: #2563eb;
      background-color: #eff6ff; /* 🔥 hover背景色 */
    }
    
    /* 🔥 專門為產品網址連結添加特殊樣式 */
    &[title*="查看詳細資訊"] {
      background-color: #f0f9ff;
      border: 1px solid #bae6fd;
      color: #0369a1;
      font-weight: 600;
      padding: 4px 8px;
      margin: 0 2px;
      
      &:hover {
        background-color: #0369a1;
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
      
      &:active {
        transform: translateY(0);
      }
    }
    
    /* 移動端觸控優化 */
    @media (max-width: 768px) {
      font-size: 15px; /* 移動端字體稍大 */
      padding: 6px 8px; /* 增大觸控區域 */
      margin: 2px 0; /* 增加垂直間距 */
      min-height: 44px; /* 確保最小觸控區域 */
      display: inline-flex;
      align-items: center;
      -webkit-tap-highlight-color: transparent;
      
      &[title*="查看詳細資訊"] {
        padding: 8px 12px;
        font-size: 15px;
        min-height: 44px;
        width: 100%;
        box-sizing: border-box;
        justify-content: center;
        margin: 4px 0;
        word-break: break-all;
      }
    }
    
    @media (max-width: 480px) {
      font-size: 14px;
      padding: 8px 10px;
      
      &[title*="查看詳細資訊"] {
        font-size: 14px;
        padding: 10px 12px;
      }
    }
  }

  /* 產品資訊區塊 */
  .product-info-block {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 16px;
    margin: 12px 0;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  /* 產品標題樣式 */
  .product-header {
    background: #f8fafc;
    border-left: 4px solid #3b82f6;
    padding: 8px 12px;
    margin: 16px 0 12px 0;
    border-radius: 0 6px 6px 0;
  }

  .product-header h3 {
    margin: 0;
    color: #1e293b;
    font-size: 16px;
    font-weight: 600;
  }

  /* 產品連結樣式 */
  .product-link {
    background-color: #f0f9ff !important;
    border: 1px solid #bae6fd !important;
    color: #0369a1 !important;
    font-weight: 600 !important;
    padding: 6px 10px !important;
    margin: 4px 0 !important;
    border-radius: 6px !important;
    display: inline-block !important;
    word-break: break-all !important;
    max-width: 100% !important;
    
    &:hover {
      background-color: #0369a1 !important;
      color: white !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    }
    
    &:active {
      transform: translateY(0) !important;
    }
    
    /* 移動端產品連結優化 */
    @media (max-width: 768px) {
      padding: 10px 12px !important;
      margin: 6px 0 !important;
      font-size: 15px !important;
      min-height: 44px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      text-align: center !important;
      line-height: 1.3 !important;
      -webkit-tap-highlight-color: transparent !important;
      touch-action: manipulation !important;
    }
    
    @media (max-width: 480px) {
      padding: 12px 14px !important;
      font-size: 14px !important;
      margin: 8px 0 !important;
    }
  }

  /* 分隔線 */
  hr {
    border: none;
    border-top: 1px solid #e2e8f0;
    margin: 16px 0;
  }
`;

function MessageBubble({ message }) {
  const isUser = message.role === 'user';

  // 🔥 自定義連結渲染器，確保所有連結都在新視窗中打開
  const markdownComponents = {
    a: ({ href, children, ...props }) => (
      <a 
        href={href} 
        target="_blank" 
        rel="noopener noreferrer"
        title="點此查看詳細資訊(在新視窗中打開)"
        className="product-link"
        {...props}
      >
        {children}
      </a>
    ),
    // 🔥 改善其他元素的渲染
    p: ({ children, ...props }) => (
      <p {...props}>{children}</p>
    ),
    strong: ({ children, ...props }) => (
      <strong {...props}>{children}</strong>
    ),
    // 🔥 自定義產品資訊區塊渲染
    h3: ({ children, ...props }) => {
      // 檢查是否為產品標題格式 【產品名稱】
      const content = children?.toString() || '';
      if (content.includes('【') && content.includes('】')) {
        return (
          <div className="product-header" {...props}>
            <h3>{children}</h3>
          </div>
        );
      }
      return <h3 {...props}>{children}</h3>;
    }
  };

  // 🔥 預處理訊息內容，改善格式問題
  const preprocessContent = (content) => {
    let processedContent = content;
    
    // 修復產品網址格式 - 創建友好的鏈接顯示
    processedContent = processedContent.replace(
      /\*\*產品網址：\s*\*\*\s*(https?:\/\/[^\s\n]+)/g,
      '**產品網址：**\n[🔗 點此查看產品詳情]($1)'
    );
    
    // 處理沒有粗體格式的產品網址
    processedContent = processedContent.replace(
      /產品網址：\s*(https?:\/\/[^\s\n]+)/g,
      '**產品網址：**\n[🔗 點此查看產品詳情]($1)'
    );
    
    // 修復聯絡電話格式
    processedContent = processedContent.replace(
      /\*\*連絡電話：\s*\*\*\s*([^\n]+)/g,
      '**連絡電話：** $1'
    );
    
    // 修復公司名稱格式
    processedContent = processedContent.replace(
      /\*\*公司：\s*\*\*\s*([^\n]+)/g,
      '**公司：** $1'
    );
    
    // 修復核心功能實現格式
    processedContent = processedContent.replace(
      /\*\*核心功能實現：\s*\*\*\s*([^\n]+)/g,
      '**核心功能實現：** $1'
    );
    
    // 修復其他特色格式
    processedContent = processedContent.replace(
      /\*\*其他特色：\s*\*\*\s*([^\n]+)/g,
      '**其他特色：** $1'
    );
    
    return processedContent;
  };

  return (
    <MessageWrapper $isUser={isUser}>
      <Avatar $isUser={isUser}>
        {isUser ? '👤' : '🤖'}
      </Avatar>
      <Bubble $isUser={isUser}>
        <ReactMarkdown components={markdownComponents}>
          {preprocessContent(message.content)}
        </ReactMarkdown>
      </Bubble>
    </MessageWrapper>
  );
}

export default MessageBubble; 